import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { Avatar, IMAGE_SIZES } from 'images'
import { FollowButton } from 'tournaments'
import { ProgressBar } from 'ui'

import type { FC } from 'react'

import type { TournamentSchema } from 'search'

type TournamentProps = {
  className?: string
  onToggleFollow?: (tournament: TournamentSchema.Tournament) => void
  tournament: TournamentSchema.Tournament
}

const Tournament: FC<TournamentProps> = ({ className, onToggleFollow, tournament }) => {
  const { stages } = tournament.tournament
  const totalStagesEnded = stages.filter((s) => s.is_ended).length
  const totalStagesFilled = stages.filter((s) => s.is_filled).length
  const progress = stages.length > 0 ? (totalStagesEnded / stages.length) * 100 : 0
  const alert = totalStagesFilled <= stages.length / 2
  const isFollowing = Number(tournament.following?.length || 0) > 0

  return (
    <div
      className={classnames(
        'border hover:border-green focus-within:border-green hover:shadow focus-within:shadow rounded',
        className,
      )}
    >
      <div className="flex gap-1 items-center px-1 pt-1">
        <Link
          className="shrink-0 font-bold truncate !no-underline"
          tabIndex={-1}
          to={`/sports/tournament/${tournament.id}`}
        >
          <Avatar fallbackIconName="trophy" size="4em" src={tournament.avatar} srcImageSize={IMAGE_SIZES.FIT_100_100} />
        </Link>
        <div className="grow flex flex-col overflow-hidden">
          <Link className="font-bold truncate" to={`/sports/tournament/${tournament.id}`}>
            {tournament.name}
          </Link>
          <div className="text-sm truncate text-greyDark pb-1">
            Temporada <b>{tournament.season}</b>
          </div>
          <div className="text-xs truncate text-greyDark">
            {tournament.discipline.sport.name}, {tournament.discipline.name}, {tournament.gender.name}
          </div>
          <b className="text-xs truncate text-greyDark">{tournament.institution.name}</b>
          <div className="flex items-center gap-2 text-sm">
            <i className={`flag ${tournament.country_code} !m-0`} />
            {tournament.is_ended && <span className="text-green">Finalizado</span>}
            {tournament.is_active ? (
              <span className="text-blue">Activo</span>
            ) : (
              <span className="text-grey">Inactivo</span>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-end items-center gap-2 text-sm">
        {!!onToggleFollow && <FollowButton isFollowing={isFollowing} tournamentId={tournament.id} />}
      </div>
      <ProgressBar alert={alert} ariaLabel="Avance del torneo" className="text-xxs" tabIndex={-1} value={progress} />
    </div>
  )
}

export default Tournament
